import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { initDatabase } from '@/lib/db'
import './assets/main.css'

async function bootstrap() {
  try {
    await initDatabase()
  } catch (err) {
    console.error('[db] init failed:', err)
    document.body.innerHTML = `<div style="padding:2rem;font-family:sans-serif;color:#fca5a5">
      <h2>数据库初始化失败</h2><p>${err.message}</p></div>`
    return
  }
  const app = createApp(App)
  app.use(createPinia())
  app.use(router)
  app.mount('#app')
}

bootstrap()
